import DecisionItem from './DecisionItem';

export default DecisionItem;
